/* eslint-disable camelcase */
import { List, ListItem, Text } from '@chakra-ui/react';
import * as _ from 'lodash';
import React from 'react';

import { FinleyValleyBankResponseTapeRow } from '@finley-technologies/valley-bank-utils';

import { ArrangementGroupSummaryLink } from '~/valleyBank/domains/ArrangementGroups/hooks/ArrangementGroupsContext';

export const getArrangementGroupNumbers = (
  receivables: FinleyValleyBankResponseTapeRow[],
): string[] => {
  const arrangementGroups = new Set(
    receivables.map(({ arrangement_group }) => arrangement_group),
  );

  const arrangementGroupsArray = _.compact(Array.from(arrangementGroups));

  return arrangementGroupsArray;
};

type CollateralAccountArrangementGroupNumbersProps = {
  receivables: FinleyValleyBankResponseTapeRow[];
};
export const CollateralAccountArrangementGroupNumbers = ({
  receivables,
}: CollateralAccountArrangementGroupNumbersProps) => {
  const arrangementGroups = getArrangementGroupNumbers(receivables);

  if (arrangementGroups.length === 0) {
    return <Text>-</Text>;
  }

  return (
    <List>
      {Array.from(arrangementGroups).map((arrangementGroupNumber) => {
        return (
          <ListItem key={arrangementGroupNumber}>
            <ArrangementGroupSummaryLink
              arrangementGroup={arrangementGroupNumber || ''}
            >
              {arrangementGroupNumber || '-'}
            </ArrangementGroupSummaryLink>
          </ListItem>
        );
      })}
    </List>
  );
};
